import { useState, useCallback } from 'react';
import { RoutesStations, getRouteStationsById } from '../types/routesStations';

const useRoutesStations = () => {
  const [ routesStations, setRoutesStations ] = useState<RoutesStations>({});

  const getRouteStationsById: getRouteStationsById = useCallback((id) => (
    routesStations[id]
  ), [routesStations]);

  const resetRoutesStations = useCallback(() => {
    setRoutesStations({})
  }, [setRoutesStations]);

  return { routesStations, setRoutesStations, getRouteStationsById, resetRoutesStations };
};

export default useRoutesStations;
